import { render, staticRenderFns } from "./AddressDerivationOptionsCard.vue?vue&type=template&id=764407df&scoped=true&"
import script from "./AddressDerivationOptionsCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddressDerivationOptionsCard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764407df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VSelect,VTextField,VTooltip})
